// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file non_medical_master/list_non_medical_master.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { NonMedicalMaster } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.ListNonMedicalMasterRequest
 */
export class ListNonMedicalMasterRequest extends Message<ListNonMedicalMasterRequest> {
  /**
   * Search term for filtering non-medical items
   *
   * @generated from field: string search = 1;
   */
  search = "";

  /**
   * Page number for pagination
   *
   * @generated from field: int32 page = 2;
   */
  page = 0;

  /**
   * Number of items per page
   *
   * @generated from field: int32 page_size = 3;
   */
  pageSize = 0;

  constructor(data?: PartialMessage<ListNonMedicalMasterRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.ListNonMedicalMasterRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListNonMedicalMasterRequest {
    return new ListNonMedicalMasterRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListNonMedicalMasterRequest {
    return new ListNonMedicalMasterRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListNonMedicalMasterRequest {
    return new ListNonMedicalMasterRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListNonMedicalMasterRequest | PlainMessage<ListNonMedicalMasterRequest> | undefined, b: ListNonMedicalMasterRequest | PlainMessage<ListNonMedicalMasterRequest> | undefined): boolean {
    return proto3.util.equals(ListNonMedicalMasterRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.ListNonMedicalMasterResponse
 */
export class ListNonMedicalMasterResponse extends Message<ListNonMedicalMasterResponse> {
  /**
   * List of non-medical master records
   *
   * @generated from field: repeated com.neulink.pharmacy.NonMedicalMaster non_medical_masters = 1;
   */
  nonMedicalMasters: NonMedicalMaster[] = [];

  /**
   * Total number of non-medical master records
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount = 0;

  constructor(data?: PartialMessage<ListNonMedicalMasterResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.ListNonMedicalMasterResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "non_medical_masters", kind: "message", T: NonMedicalMaster, repeated: true },
    { no: 2, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListNonMedicalMasterResponse {
    return new ListNonMedicalMasterResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListNonMedicalMasterResponse {
    return new ListNonMedicalMasterResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListNonMedicalMasterResponse {
    return new ListNonMedicalMasterResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListNonMedicalMasterResponse | PlainMessage<ListNonMedicalMasterResponse> | undefined, b: ListNonMedicalMasterResponse | PlainMessage<ListNonMedicalMasterResponse> | undefined): boolean {
    return proto3.util.equals(ListNonMedicalMasterResponse, a, b);
  }
}

